/* Content for the CANTO Annual Conference 2027 Call for Participation page.
   Sourced from CANTO_2027_Call_for_Participation.pdf (the authoritative copy) —
   keep this file and the PDF in step when the client sends revisions. */

const data = {
  eyebrow: 'CANTO Annual Conference 2027',
  title: 'Call for Participation',
  pdfTitle: 'Download the CANTO 2027 Call for Participation',
  submitLabel: 'Submit Your Proposal',
  tagline: 'Shape the Digital Future of the Caribbean',

  // Dates are baked into banner.png as well; update both together.
  submissionsOpen: '14 September 2026',
  submissionsClose: '1 November 2026',

  formUrl:
    'https://docs.google.com/forms/d/e/1FAIpQLSdr32seaVsLpHtI7o5gdcfp6SXMiHvdmXEsy6VjMmhMEWh24Q/viewform?usp=header',
  pdfUrl: '/assets/CANTO_2027_Call_for_Participation.pdf',
  bannerUrl: '/assets/call_for_participation/banner.png',
  // Scenery-only slice of the banner — the full artwork's headline would
  // ghost through the footer band's overlay.
  footerBgUrl: '/assets/call_for_participation/footer_bg.png',

  intro: [
    "CANTO's Annual Conference brings together the Caribbean's telecommunications operators, technology vendors, governments, regulators, investors, and innovators. In 2027, we are inviting practitioners, executives, and policymakers who are building the region's digital future to help shape the programme.",
    'This is an industry forum, not an academic conference. There are no academic prerequisites. If you have a real story, a working solution, a policy insight, an investment thesis, or a product that serves the Caribbean, we want to hear from you.',
  ],

  audiences: [
    { icon: 'executives', label: 'Executives' },
    { icon: 'policymakers', label: 'Policymakers' },
    { icon: 'technology', label: 'Technology Leaders' },
    { icon: 'investors', label: 'Investors' },
    { icon: 'entrepreneurs', label: 'Entrepreneurs' },
    { icon: 'innovators', label: 'Innovators' },
  ],

  themes: [
    'AI and Digital Transformation',
    '5G, LEO and Next-Gen Networks',
    'Cybersecurity and Digital Trust',
    'Digital Finance, Fintech and Payments',
    'Regulatory Innovation and Spectrum',
    'Investment and Infrastructure Finance',
    'Smart Cities, IoT and Energy',
    'Digital Health, Education and Impact',
    'Climate-Resilient Connectivity',
    'Future of Work and Human Capital',
    'Data Economy and AI Governance',
    'Women in Tech and Leadership',
  ],

  formats: [
    {
      icon: 'spotlight',
      label: 'Spotlight Showcase',
      duration: '15 min',
      desc: 'A solo presentation to the full audience. Ideal for product launches, case studies, and announcements.',
    },
    {
      icon: 'keynote',
      label: 'Keynote within Panel',
      duration: '20–30 min',
      desc: 'Be the featured voice within a moderated panel discussion.',
    },
    {
      icon: 'panelist',
      label: 'Panelist Position',
      duration: '45–60 min',
      desc: 'Join a multi-stakeholder panel of 4 to 5 experts.',
    },
    {
      icon: 'dialogue',
      label: 'CEO / Executive Dialogue',
      duration: '30 min',
      desc: 'An intimate fireside chat. By invitation or through sponsorship.',
    },
    {
      icon: 'workshop',
      label: 'Workshop / Summit Session',
      duration: '90–120 min',
      desc: 'A fully branded deep-dive session that you curate.',
    },
    {
      icon: 'pitch',
      label: 'Startup Pitch',
      duration: '5–10 min',
      desc: 'Pitch your innovation in the Innovation Pavilion.',
    },
  ],

  contact: {
    name: 'Andrea Lewis-Francis',
    role: 'Business Support Officer, CANTO',
    email: 'alewis@canto.org',
  },
};

export default data;
